import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getFlatProfilePathname } from '../../../utils/link'
import { ListItem } from '../../ListItem'

import { isNeedToShowEntityProfileFlatItemIcons } from './EntityProfileFlatItem.utils'

import * as styles from './EntityProfileFlatItem.module.css'

import FlatIcon from '../../../icons/flat.svg'

function EntityProfileFlatItem({
  className = styles.EntityProfileFlatItem,
  value,
  ...restProps
}) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const { availableSections } = useInitData()

  const link = getFlatProfilePathname({ availableSections, id: value })

  function handleClickFlat(_value, event) {
    handleClick({
      event,
      link,
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  function handleMouseDownFlat(_value, event) {
    handleMouseDown({ event, link })
  }

  return (
    <ListItem
      {...restProps}
      ListIcon={FlatIcon}
      className={className}
      isNeedToShowIcons={isNeedToShowEntityProfileFlatItemIcons}
      textClassName={styles.text}
      tooltipProps={{ placement: FLOATING_ELEMENT_PLACEMENT.top }}
      onClick={handleClickFlat}
      onMouseDown={handleMouseDownFlat}
    />
  )
}

export default EntityProfileFlatItem
